import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { RequestAccessConfirmationModalProps } from './RequestAccessConfirmationModal';

export const LazyRequestAccessConfirmationModal: React.FunctionComponent<RequestAccessConfirmationModalProps> = (
  props: RequestAccessConfirmationModalProps,
) => {
  const RequestAccessConfirmationModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "request-access-confirmation-modal" */ './RequestAccessConfirmationModal'
      ),
    { preload: false, namedImport: 'RequestAccessConfirmationModal' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-smoothie',
          feature: 'requestAccessV3',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <RequestAccessConfirmationModal {...props} />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
